module.exports = __webpack_public_path__ + "static/img/xianshangico.1f18d6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/xianshangico.png
// module id = gXrg
// module chunks = 1